/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { GoogleLogin } from 'react-google-login';
import { GoogleIcon } from "localResouces";
import ExternalLoginButtonContainer from './ExternalLoginButtonContainer';

const defaultButtonText = "Mit Google anmelden";

export default function Login(props) {
  const { clientId, onSuccess, onFailure, disabled, buttonText } = props;

  const onSuccessHandler = (response) => {
    //console.log("GOOGLE LOGIN RESULT", response);
    onSuccess(response.tokenId);
  };

  const onFailureHandler = (response) => {
    //console.log("GOOGLE LOGIN FAILURE", response);
    onFailure(response);
  };

  return (
    <ExternalLoginButtonContainer>
      <GoogleLogin
        clientId={clientId}
        onSuccess={(r) => onSuccessHandler(r)}
        onFailure={(r) => onFailureHandler(r)}
        cookiePolicy='single_host_origin'
        isSignedIn={false}
        disabled={disabled}
        render={renderProps => (
          <a onClick={renderProps.onClick} disabled={renderProps.disabled} target="_blank" className="gmBtn"><img src={GoogleIcon} alt="" /><em>{buttonText || defaultButtonText}</em></a>
        )}
      />
    </ExternalLoginButtonContainer>
  );
}